<template>

  <v-container fluid style="background:#f6f6f6">

  <v-row class="ml-3 mr-3 pl-3" justify="start" align="center">

    <template v-if="grade >= 80">
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0 mr-3">
        <comdialog2  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog2>
      </v-col>
      <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
        <eventdialog2  :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog2>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
        <eventdialog2 :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog2>
      </v-col>
    </template>
    <v-spacer/>
    
    <v-col cols="12" md="5" >
      <template v-if="this.$hostname == 'admin.mnccom-reg.com'">
      </template>
      <template v-else-if="this.$hostname == 'admin.pictcloud.com'">
      </template>
      <template v-else>
        <div class="d-flex justify-end">
          <a class="top_btn" @click="movenotice">{{$t('welcome_notice')}}</a>
          <a class="top_btn2 ml-1" @click="manual_movie">{{$t('welcome_use')}}</a>
          <a class="top_btn2" @click="manual">{{$t('welcome_manual')}}</a>
        </div>
      </template>
    </v-col>
    
  </v-row>
  

  <v-row class="ml-3 mr-3">
    
    <v-col cols="12" md="5">
      <v-col class="quick_area_round">
        <v-row>
          <v-col cols="6" class="pa-0">
            <label style="font-size:20px;color:#000000;margin-left:20px;font-weight:bold">{{$t('welcome_reg_title')}}</label>
            <div class="d-flex flex-column" style="margin-left:20px;margin-top:32px">
              <label style="font-size:12px;color:#898989;">{{$t('welcome_reg_name3')+": "+priceToString(total_show)}}</label>
              <label style="font-size:12px;color:#898989;">{{$t('welcome_reg_today')+": "+priceToString(today_show)}}</label>
            </div>
          </v-col>
          <v-col cols="6" class="pa-0" >
            <div class="d-flex align-center">

              <div>
                <div class="d-flex align-center">
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4" cy="4" r="4" fill="#FFCD39"/>
                  </svg>
                  <span class="percent_text ml-2">{{NOWRATE}}%</span>
                  <v-btn class="ml-1" small color="white" @click="search_run" elevation="0">
                    <svg width="23" height="13" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.7998 1H19.7331V9.23333" stroke="#FFCD39" stroke-width="1.8"/>
                      <path d="M17.1999 11.768H3.2666V4.16797" stroke="#FFCD39" stroke-width="1.8"/>
                      <path d="M1.3636 4.79824L0.727208 5.43464L2 6.70743L2.6364 6.07103L1.3636 4.79824ZM2.63027 3.53157L1.3636 4.79824L2.6364 6.07103L3.90306 4.80436L2.63027 3.53157Z" fill="#FFCD39"/>
                      <path d="M21.6364 8.60215L22.2728 7.96576L21 6.69296L20.3636 7.32936L21.6364 8.60215ZM20.3697 9.86882L21.6364 8.60215L20.3636 7.32936L19.0969 8.59603L20.3697 9.86882Z" fill="#FFCD39"/>
                      <path d="M3.2666 4.16797L4.53327 5.43464" stroke="#FFCD39" stroke-width="1.8" stroke-linecap="square"/>
                      <path d="M19.7334 9.23242L18.4667 7.96576" stroke="#FFCD39" stroke-width="1.8" stroke-linecap="square"/>
                    </svg>
                  </v-btn>
                </div>
                <div class="d-flex flex-column mt-3">
                  <label style="font-size:12px;color:#898989;">{{$t('welcome_reg_rate')}}</label>
                  <label style="font-size:12px;color:#898989;">{{NOWDATE}}{{$t('welcome_reg_standard')}}</label>
                </div>
              </div>

              <div class="ml-5">
                <canvas ref="drawarea" style="width:100px"/>
              </div>

            </div>
          </v-col>
        </v-row>

        <v-row justify="center" class="mt-5">
          <v-col cols="6" align="end" class="pa-0 pl-1">
            <div class="d-flex flex-column dashboard_round">
              <label class="dash_bluetext">{{$t('welcome_reg_name1')}}</label>
              <label class="welcome_value">{{ priceToString(before_totalcnt) }}</label>
              <div class="dash_text">{{$t('welcome_reg_today')}}</div>
              <div class="dash_cnttext">{{ priceToString(before_todaycnt) }}</div>
            </div>
          </v-col>
          <v-col cols="6" align="end" class="pa-0 pr-1">
            <div class="d-flex flex-column dashboard_round">
              <label class="dash_bluetext">{{$t('welcome_reg_name2')}}</label>
              <label class="welcome_value" >{{ priceToString(after_totalcnt) }}</label>
              <div class="dash_text">{{$t('welcome_reg_today')}}</div>
              <div class="dash_cnttext">{{ priceToString(after_todaycnt) }}</div>
            </div>
          </v-col>
        </v-row>

        <v-row justify="center" class="mt-3">
          <!-- 
          <v-col cols="6" align="end" class="pa-0 pl-1">
            <div class="d-flex flex-column dashboard_round">
              <label class="dash_bluetext">{{$t('welcome_reg_name3')}}</label>
              <label class="welcome_value">{{ priceToString(total_show) }}</label>
              <div class="dash_text">{{$t('welcome_reg_today')}}</div>
              <div class="dash_cnttext">{{ priceToString(today_show) }}</div>
            </div>
          </v-col>
          -->
          <v-col cols="6" align="end" class="pa-0 pr-1">
            <div class="d-flex flex-column dashboard_round">
              <label class="dash_bluetext">{{$t('welcome_reg_name4')+"(KRW)"}}</label>
              <label class="welcome_value" >{{ priceToString(total_cost) }}</label>
              <div class="dash_text">{{$t('welcome_reg_today')+"(KRW)"}}</div>
              <div class="dash_cnttext">{{ priceToString(today_cost) }}</div>
            </div>
          </v-col>
          <v-col cols="6" align="end" class="pa-0 pr-1">
            <div class="d-flex flex-column dashboard_round">
              <label class="dash_bluetext">{{$t('welcome_reg_name4')+"(USD)"}}</label>
              <label class="welcome_value" >{{ priceToString(total_cost2) }}</label>
              <div class="dash_text">{{$t('welcome_reg_today')+"(USD)"}}</div>
              <div class="dash_cnttext">{{ priceToString(today_cost2) }}</div>
            </div>
          </v-col>
        </v-row>
        
      </v-col>
    </v-col>

    <v-col cols="12" md="7">

      <v-col class="quick_area_round">
        <v-row>
          <v-col cols="6" class="pa-0">
            <label style="font-size:20px;color:#000000;margin-left:20px;font-weight:bold">{{$t('welcome_pay_title')}}</label>
          </v-col>
        </v-row>

        <v-row justify="end" align="center" class="mt-7">

          <v-col cols="4" class="pa-0 pr-1" align="end">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#4e6ef7" class="mr-2" elevation="1" small @click="getallinfo()"><v-icon>mdi-sync</v-icon></v-btn>
          </v-col>
    
          <v-col cols="4" class="pa-0 pr-1">
            <div class="d-flex align-center dashboard_round_small">
              <label class="dash_text" style="margin-top:0px">{{$t('welcome_pay_tpay')}}</label>
              <label class="print_text_value ml-auto" style="color:#627BFF">{{ priceToString(total_amount) }}</label>
            </div>
          </v-col>
          <v-col cols="4" class="pa-0 pr-1">
            <div class="d-flex align-center dashboard_round_small">
              <label class="dash_text" style="margin-top:0px">{{$t('welcome_pay_name2')}}</label>
              <label class="print_text_value ml-auto">{{ priceToString( Number(vpprint_totalcnt)+Number(spprint_totalcnt) ) }}</label>
            </div>
          </v-col>
          <!-- 관람객, 관계자 카운트 (사용안함)
          <v-col cols="4" align="end" class="pa-0 pr-1">
            <div class="d-flex flex-column dashboard_round">
              <label class="dash_bluetext">{{$t('welcome_pay_visitor')}}</label>
              <label class="welcome_value" >{{ priceToString(vpprint_totalcnt) }}</label>
            </div>
          </v-col>
          <v-col cols="4" align="end" class="pa-0 pr-1">
            <div class="d-flex flex-column dashboard_round">
              <label class="dash_bluetext">{{$t('welcome_pay_step')}}</label>
              <label class="welcome_value" >{{ priceToString(spprint_totalcnt) }}</label>
            </div>
          </v-col>
          -->
        </v-row>        

          <v-row justify="center" class="mt-3">
            <v-col cols="4" align="end" class="pa-0 pl-1">
              <div class="d-flex flex-column dashboard_round">
                <label class="dash_bluetext">{{$t('welcome_pay_talk')}}</label>
                <label class="welcome_value">{{ priceToString(talk_totalcnt) }}</label>
                <div class="dash_text">{{$t('welcome_reg_price')}}</div>
                <div class="dash_cnttext">{{ priceToString(talk_amount) }}</div>
              </div>
            </v-col>
            <v-col cols="4" align="end" class="pa-0">
              <div class="d-flex flex-column dashboard_round">
                <label class="dash_bluetext">{{$t('welcome_pay_mail')}}</label>
                <label class="welcome_value">{{ priceToString(mail_totalcnt) }}</label>
                <div class="dash_text">{{$t('welcome_reg_price')}}</div>
                <div class="dash_cnttext">{{ priceToString(mail_amount) }}</div>
              </div>
            </v-col>
            <v-col cols="4" align="end" class="pa-0 pr-1">
              <div class="d-flex flex-column dashboard_round">
                <label class="dash_bluetext">{{$t('welcome_pay_name1')}}</label>
                <label class="welcome_value">{{ priceToString(place_totalcnt) }}</label>
                <div class="dash_text">{{$t('welcome_reg_price')}}</div>
                <div class="dash_cnttext">{{ priceToString(place_amount) }}</div>
              </div>
            </v-col>
          </v-row>

          <v-row justify="center" class="mt-3">
            <v-col cols="4" align="end" class="pa-0 pl-1">
              <div class="d-flex flex-column dashboard_round">
                <label class="dash_bluetext">{{$t('welcome_pay_name3')}}</label>
                <label class="welcome_value">{{ priceToString(invit_totalcnt) }}</label>
                <div class="dash_text">{{$t('welcome_reg_price')}}</div>
                <div class="dash_cnttext">{{ priceToString(invit_amount) }}</div>
              </div>
            </v-col>
            <v-col cols="4" align="end" class="pa-0">
              <div class="d-flex flex-column dashboard_round">
                <label class="dash_bluetext">{{$t('welcome_pay_name4')}}</label>
                <label class="welcome_value" >{{ priceToString(sms_totalcnt) }}</label>
                <div class="dash_text">{{$t('welcome_reg_price')}}</div>
                <div class="dash_cnttext">{{ priceToString(sms_amount) }}</div>
              </div>
            </v-col>
            <v-col cols="4" align="end" class="pa-0 pr-1">
              <div class="d-flex flex-column dashboard_round">
                <label class="dash_bluetext">{{$t('welcome_pay_name5')}}</label>
                <label class="welcome_value" >{{ priceToString(email_totalcnt) }}</label>
                <div class="dash_text">{{$t('welcome_reg_price')}}</div>
                <div class="dash_cnttext">{{ priceToString(email_amount) }}</div>
              </div>
            </v-col>
          </v-row>
        
      </v-col>
    </v-col>
    

    <v-col cols="12">

      <v-col>

        <v-row>
          <v-col cols="12" class="pa-0">
            <label style="font-size:20px;color:#000000;margin-left:30px;font-weight:bold">{{$t('welcome_menu_title')}}</label>
          </v-col>
        </v-row>
        <v-row style="height:10px"></v-row>

        <v-row justify="start" align="center">
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('EventList',$t('welcome_qmenu1'))" elevation="0">
              <img :src="require('@/assets/dasy_icon1.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu1')}}</span>
            </div>
          
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('EventOption',$t('welcome_qmenu2'))" elevation="0">
              <img :src="require('@/assets/dasy_icon2.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu2')}}</span>
            </div>
          
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('EventInfo',$t('welcome_qmenu3'))" elevation="0">
              <img :src="require('@/assets/dasy_icon3.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu3')}}</span>
            </div>
          
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('GuestDesign',$t('welcome_qmenu4'))" elevation="0">
              <img :src="require('@/assets/dasy_icon4.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu4')}}</span>
            </div>
          
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('EventUserList',$t('welcome_qmenu5'))" elevation="0">
              <img :src="require('@/assets/dasy_icon5.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu5')}}</span>
            </div>
          
        </v-row>

        <v-row justify="start" align="center" >
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('EventInvit',$t('welcome_qmenu6'))" elevation="0">
              <img :src="require('@/assets/dasy_icon6.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu6')}}</span>
            </div>
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('SmsList',$t('welcome_qmenu7'))" elevation="0">
              <img :src="require('@/assets/dasy_icon7.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu7')}}</span>
            </div>
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('EmailList',$t('welcome_qmenu8'))" elevation="0">
              <img :src="require('@/assets/dasy_icon8.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu8')}}</span>
            </div>
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('AdminStat',$t('welcome_qmenu9'))" elevation="0">
              <img :src="require('@/assets/dasy_icon9.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu9')}}</span>
            </div>
          
            <div class="quick_btn_round d-flex align-center" style="padding-left:30px" @click="quickmenu('ChartPayment',$t('welcome_qmenu10'))" elevation="0">
              <img :src="require('@/assets/dasy_icon10.png')" >
              <span :class="$i18n.locale == 'ko' ? 'quick_btn_text' : 'quick_btn_text2'" style="padding-left:20px">{{$t('welcome_qmenu10')}}</span>
            </div>
          
        </v-row>
        
        <v-row style="height:30px"></v-row>

      </v-col>


    </v-col>    

  </v-row>
  

  </v-container>
</template>

<script>
import Chart from 'chart.js/auto';
import moment from 'moment'
export default {

    beforeDestroy(){
      if(this.myChart1 != null){
        this.myChart1.destroy();
      }
    },

    data: () => ({

      myChart1: null,

      NOWDATE:"",   //조회기준시간
      NOWRATE:"",   //실시간관람율

      before_totalcnt:0,
      before_todaycnt:0,
      after_totalcnt:0,
      after_todaycnt:0,
      total_show:0,
      today_show:0,
      total_cost:0,
      total_cost2:0,
      today_cost:0,
      today_cost2:0,

      place_totalcnt:0,
      spprint_totalcnt:0,
      vpprint_totalcnt:0,
      invit_totalcnt:0,
      sms_totalcnt:0,
      email_totalcnt:0,

      total_amount:0,
      place_amount:0,
      invit_amount:0,
      sms_amount:0,
      email_amount:0,
      part_type:0,

      talk_totalcnt:0,
      talk_amount:0,
      mail_totalcnt:0,
      mail_amount:0,

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      
      defaultItem: {
          IDX:0,
          TITLE:'',
          DESC:'',
          TYPE:0,
          FILE1:'',
          FILE2:'',
          FILE3:'',
      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '제목', value: 'TITLE', sortable: true, align:'center',width:'70%'},
        {text: '등록일', value: 'REG_DATE', sortable: true, align:'center' },
      ],
      itemList: [],

      sort_name: 'REG_DATE',
      sort_type: true,    //true : DESC, false: ASC
      
      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

      //추가 변수들
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,


    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }

    },

    create(){
      
    },

    methods: {

      movenotice(){
        this.$router.push("Notice");
      },

      manual_movie(){
        this.$alert(this.$t("welcome_info1"));
      },
      manual(){
        this.$alert(this.$t("welcome_info1"));
      },

      quickmenu(router_name, menuname){
        this.$EventBus.$emit('movepageresult', router_name, menuname);
      },

      getallinfo(){
        this.$confirm(this.$t("eventinvit_col22"))
        .then(() => {
          this.reloadsyncinfo();
        });
      },

      reloadsyncinfo(){

        this.$http.post(this.$host+'/api/ReloadSyncInfo',{
          EVENT_IDX : this.SEARCH_EVENT_IDX
        , COM_IDX: this.SEARCH_COM_IDX
        , ADMIN_IDX: this.$session.get("ADMIN_IDX")
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                this.loadpageinfo();

                /*
                this.$alert(this.$t('common_process_msg')).then(()=>{
                  this.loadpageinfo();
                });
                */
                
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });
      },


      loadpageinfo(p){

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/WelcomeInfo',{
                EVENT_IDX : this.SEARCH_EVENT_IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;

            if(result.data.resultCode == 0){
              
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                this.before_totalcnt = result.data.BEFORE_TOTALCNT;
                this.before_todaycnt = result.data.BEFORE_TODAYCNT;
                this.after_totalcnt = result.data.AFTER_TOTALCNT;
                this.after_todaycnt = result.data.AFTER_TODAYCNT;
                this.total_cost     = result.data.TOTAL_COST;
                this.total_cost2    = result.data.TOTAL_COST2;
                this.today_cost     = result.data.TODAY_COST;
                this.today_cost2    = result.data.TODAY_COST2;
                this.total_show     = result.data.TOTAL_SHOW;
                this.today_show     = result.data.TODAY_SHOW;

                this.place_totalcnt   = result.data.PLACE_TOTALCNT; 
                this.spprint_totalcnt = result.data.SPPRINT_TOTALCNT; 
                this.vpprint_totalcnt = result.data.VPPRINT_TOTALCNT; 
                this.invit_totalcnt   = result.data.INVIT_TOTALCNT; 
                this.sms_totalcnt     = result.data.SMS_TOTALCNT; 
                this.email_totalcnt   = result.data.EMAIL_TOTALCNT; 

                this.talk_totalcnt   = result.data.TALK_TOTALCNT; 
                this.mail_totalcnt   = result.data.MAIL_TOTALCNT; 
                
                this.place_amount   = result.data.PLACE_AMOUNT;
                this.invit_amount   = result.data.INVIT_AMOUNT; 
                this.sms_amount     = result.data.SMS_AMOUNT; 
                this.email_amount   = result.data.EMAIL_AMOUNT; 
                this.talk_amount    = result.data.TALK_AMOUNT; 
                this.mail_amount    = result.data.MAIL_AMOUNT; 
                this.total_amount   = Number(this.place_amount)+Number(this.invit_amount)+Number(this.sms_amount)+Number(this.email_amount)+Number(this.talk_amount)+Number(this.mail_amount);

                this.part_type      = result.data.PART_TYPE; 
                
                this.NOWDATE   = moment().format("YYYY-MM-DD hh:mm");

                //실시간 관람율
                this.NOWRATE = Math.round(this.total_show / (this.before_totalcnt + this.after_totalcnt) * 100);
                if(isNaN(this.NOWRATE)){
                  this.NOWRATE = 0;
                }


                //차트 그리기
                const ctx1 = this.$refs.drawarea;
                //캔버스 초기화
                if(this.myChart1 != null){
                  this.myChart1.destroy();
                }

                const pie1 = []; //접수
                pie1.push(this.NOWRATE);
                pie1.push(100-this.NOWRATE);
                const datas1 = {
                  labels:[this.$t('welcome_chart_name1'), this.$t('welcome_chart_name2')],
                  datasets:[
                      { data:pie1,  backgroundColor: ['rgb(255, 205, 57)', 'rgb(255, 240, 196)'], borderWidth:5, hoverOffset: 1}
                  ],
                };
                const options1 = {
                  responsive: true,
                  cutout: '60%',
                  plugins:{
                    tooltip: {
                      callbacks: {
                        label:function(context){ 
                          var label = context.label || '';
                          if (label) {
                            label += ': ';
                          }
                          label += context.raw + '%'; // 값에 '%'를 추가하여 반환
                          return label;
                        }
                      }
                    },                  
                    legend: {display: false},
                  }
                };        
                this.myChart1 = new Chart(ctx1, {type:'doughnut', data:datas1, options: options1});     
 
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.before_totalcnt = 0;
              this.before_todaycnt = 0;
              this.after_totalcnt = 0;
              this.after_todaycnt = 0;
              this.total_cost     = 0;
              this.total_cost2    = 0;
              this.today_cost     = 0;
              this.today_cost2    = 0;
              this.total_show     = 0;
              this.today_show     = 0;

              this.place_totalcnt   = 0;
              this.spprint_totalcnt = 0;
              this.vpprint_totalcnt = 0;
              this.invit_totalcnt   = 0;
              this.sms_totalcnt     = 0;
              this.email_totalcnt   = 0;

              this.talk_totalcnt   = 0;
              this.mail_totalcnt   = 0;
              
              this.place_amount   = 0;
              this.invit_amount   = 0;
              this.sms_amount     = 0;
              this.email_amount   = 0;
              this.talk_amount    = 0;
              this.mail_amount    = 0;
              this.total_amount   = 0;

              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },


      initpage(){
        this.search_run();
      },      

      //검색
      search_run(){
        this.loadpageinfo();
      },

      downloadFile(file_url){

        this.$http.get(file_url,{responseType:'blob'})
        .then(response=>{
          const blob = new Blob([response.data])
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = "download"
          link.click()
          URL.revokeObjectURL(link.href)
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error=>{
          
        });

      },



      comsearchclear(){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.search_run();
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.search_run();
      },

      //검색조건 이벤트 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.search_run();
      },

      priceToString(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

.top_btn{
  color:white !important;
  background-color:#627BFF !important;
  font-size:15px !important;
  font-weight:bold !important;
  width:113px !important;
  height: 32px;
  text-align: center;
  line-height: 32px;
  min-width: 113px !important;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.top_btn2{
  color:white !important;
  background-color:#627BFF !important;
  font-size:15px !important;
  font-weight:bold !important;
  width:113px !important;
  height: 32px;
  text-align: center;
  line-height: 32px;
  min-width: 113px !important;
}

.percent_text{
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 44px;
  display: flex;
  align-items: center;
  color: #FFCD39;
}

.v-btn__content {
    display:flex;
    flex-direction:column;
}

</style>